import React from "react";

const ProfileDetail = ({ isBrand, profileData,handleConnect,triggeYoutubeConnect }) => {
 // console.log(isBrand, profileData);
// console.log(isBrand)
  return (
    <>
      <div className="flex flex-wrap w-100">
        <div className="w-full flex flex-col font-black border-1 rounded-xl border-gray-500 p-3">
          <h4 className="text-lg font-bold mb-0">Description</h4>
          <p className="mb-0 text-sm " style={{ fontFamily: "Gilroy-light" }}>
            {profileData?.bio}
          </p>
        </div>

        <div className="w-full flex flex-wrap">
          <div className="w-full md:w-1/2 flex flex-col font-black p-3">
            <h4 className="text-lg font-bold mb-2">Genre</h4>
            <div className="flex items-center">
              {profileData?.niche?.map((item, index) => (
                <React.Fragment key={index}>
                  <span className="text-gray-700 text-sm">{item}</span>
                  {index < profileData.niche.length - 1 && (
                    <span className="mx-2 text-sm">|</span>
                  )}
                </React.Fragment>
              ))}
              <button
                className="flex items-center text-pink-500 ml-4 text-sm"
               
                style={{
                  cursor:
                    profileData?.userType === "Influencer"
                      ? "pointer"
                      : "not-allowed",
                  color:
                    profileData?.userType === "Influencer"
                      ? undefined
                      : "#ccc"
                }}
              >
                <span className="text-xl font-bold mr-1">+</span> Add More
              </button>
            </div>
          </div>

          <div className="w-full md:w-1/2 flex flex-col font-black p-3">
            <h4 className="text-lg font-bold mb-2">Language known</h4>
            <div className="flex items-center text-sm">
              {profileData?.language?.map((item, index) => (
                <React.Fragment key={index}>
                  <span className="text-gray-700">{item}</span>
                  {index < profileData.language.length - 1 && (
                    <span className="mx-2">|</span>
                  )}
                </React.Fragment>
              ))}
              <button
                className="flex items-center text-pink-500 ml-4"
               
                style={{
                  cursor:
                    profileData?.userType === "Influencer"
                      ? "pointer"
                      : "not-allowed",
                  color:
                    profileData?.userType === "Influencer"
                      ? undefined
                      : "#ccc"
                }}
              >
                <span className="text-xl font-bold mr-1">+</span> Add More
              </button>
            </div>
          </div>
        </div>

        <div className="w-full flex flex-wrap">
          <div className="w-full md:w-1/2 flex flex-col font-black p-3">
            <h4 className="text-lg font-bold mb-2">Brand Collaborated</h4>
            <div className="flex items-center text-sm">
              {profileData?.brands?.map((item, index) => (
                <React.Fragment key={index}>
                  <span className="text-gray-700">{item}</span>
                  {index < profileData.niche.length - 1 && (
                    <span className="mx-2">|</span>
                  )}
                </React.Fragment>
              ))}
              <button
                className="flex items-center text-pink-500 ml-4"
               
                style={{
                  cursor:
                    profileData?.userType === "Influencer"
                      ? "pointer"
                      : "not-allowed",
                  color:
                    profileData?.userType === "Influencer"
                      ? undefined
                      : "#ccc"
                }}
              >
                <span className="text-xl font-bold mr-1">+</span> Add More
              </button>
            </div>
          </div>
        </div>

        {profileData?.instaId ? (
          <div className="w-full md:w-1/3 p-3">
            <div className="border-1 rounded-lg border-gray-500 p-3 ">
              <div className="flex items-center flex-col mb-4">
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png"
                  alt="Instagram"
                  className="w-8 h-8 mr-2"
                />
                <h3 className="text-lg "  onClick={
                  !isBrand
                    ? handleConnect
                    : undefined
                }>
                  {profileData?.instaUsername || "Instagram Profile"}
                </h3>
              </div>
              <div className="flex justify-between text-center">
                <div>
                  <h4 className="text-lg font-bold">
                    {profileData?.followers || "0"}
                  </h4>
                  <p className="text-gray-500 text-[9px]">Followers</p>
                </div>

                <div>
                  <h4 className="text-lg font-bold">
                    {profileData?.following || "0"}
                  </h4>
                  <p className="text-gray-500 text-[9px]">following</p>
                </div>

                <div>
                  <h4 className="text-lg font-bold">
                    {profileData?.ER + "%" || "0%"}
                  </h4>
                  <p className="text-gray-500 text-[9px]">Engagement Rate</p>
                </div>

                <div>
                  <h4 className="text-lg font-bold">
                    {profileData?.totalPost || "0"}
                  </h4>
                  <p className="text-gray-500 text-[9px]">Content</p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="w-full md:w-1/3 p-3">
            <div className="border-1 flex items-center rounded-lg border-gray-500 p-3 cursor-pointer hover:bg-gray-100">
              <span>
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png"
                  alt="Instagram"
                  className="w-8 h-8 mr-2"
                />
              </span>

              <span
                onClick={
                  !isBrand
                    ? handleConnect
                    : undefined
                }
                style={{
                  cursor:
                    profileData?.userType === "Influencer"
                      ? "pointer"
                      : "not-allowed",
                  color:
                    profileData?.userType === "Influencer"
                      ? undefined
                      : "#ccc"
                }}
              >
                Add Instagram
              </span>
            </div>
          </div>
        )}

        {profileData?.youtube?.chennalData?.id ? (
          <div className="w-full md:w-1/3 p-3">
            <div className="border-1 rounded-lg border-gray-500 p-3">
              <div className="flex flex-col items-center mb-4">
                <img
                  src="https://cdn.iconscout.com/icon/free/png-256/free-youtube-logo-icon-download-in-svg-png-gif-file-formats--social-media-70-flat-icons-color-pack-logos-432560.png?f=webp&w=256"
                  alt="YouTube"
                  className="w-8 h-8 mr-2"
                />
                <h3 className="text-lg font-bold">
                  {profileData?.youtube?.chennalData?.snippet?.localized
                    ?.title || "YouTube Profile"}
                </h3>
              </div>

              <div className="flex justify-between text-center">
                <div>
                  <h4 className="text-lg font-bold">
                    {profileData?.youtube?.chennalData?.statistics
                      ?.subscriberCount || "0"}
                  </h4>
                  <p className="text-gray-500 text-[9px]">Subscribers</p>
                </div>

                <div>
                  <h4 className="text-lg font-bold">
                    {profileData?.youtube?.chennalData?.statistics
                      ?.videoCount || "0"}
                  </h4>
                  <p className="text-gray-500 text-[9px]">Videos</p>
                </div>

                <div>
                  <h4 className="text-lg font-bold">
                    {profileData?.youtube?.chennalData?.statistics?.viewCount ||
                      "0"}
                  </h4>
                  <p className="text-gray-500 text-[9px]">Total Views</p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="w-full md:w-1/3 p-3">
            <div className="border-1 flex items-center rounded-lg border-gray-500 p-3 cursor-pointer hover:bg-gray-100">
              <span>
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/4/42/YouTube_icon_%282013-2017%29.png"
                  alt="YouTube"
                  className="w-8 h-8 mr-2"
                />
              </span>

              <span
                onClick={
                  !isBrand
                    ? handleConnect
                    : undefined
                }
                style={{
                  cursor:
                    profileData?.userType === "Influencer"
                      ? "pointer"
                      : "not-allowed",
                  color:
                    profileData?.userType === "Influencer"
                      ? undefined
                      : "#ccc"
                }}
              >
                Add Youtube
              </span>
            </div>
          </div>
        )}

        {/* Add Other Socials */}
        <div className="p-3">
          <div className="border-1 rounded-lg border-gray-300 p-3  flex justify-center items-center">
            <button
              className="flex items-center text-[#ff007b]"
              onClick={
                !isBrand
                  ? handleConnect
                  : undefined
              }
              style={{
                cursor:
                  profileData?.userType === "Influencer"
                    ? "pointer"
                    : "not-allowed",
                color:
                  profileData?.userType === "Influencer"
                    ? undefined
                    : "#ccc"
              }}
            >
              <span className="text-xl font-bold mr-1">+</span> Add Other
              Socials
            </button>
          </div>
        </div>

        {/* Reviews */}
        <div className="w-full p-3">
          <div className="p-5 flex flex-col ">
            <h2 className="text-xl font-bold mb-2">Reviews</h2>
            <p className="text-gray-500 text-[9px]">No reviews yet</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfileDetail;
